import React from 'react'
import { useSelector } from 'react-redux'

const Debug = () => {
  const cards = useSelector((state) => state.cards)

  return (
    <div>
      {Object.keys(cards)
        .filter((name) => cards[name].typo)
        .map((name) => (
          <div class='alert alert-warning' role='alert'>
            [edhrec-plugin:{cards[name].tag}:typo] {name}
          </div>
        ))}
      {Object.keys(cards)
        .filter((name) => cards[name].error)
        .map((name) => (
          <div class='alert alert-danger' role='alert'>
            [edhrec-plugin:{cards[name].tag}:error] {name}
          </div>
        ))}
    </div>
  )
}

export default Debug
